let _shadowHost: HTMLElement | undefined;

export function setExplorerShadowHost(host: HTMLElement): void {
	_shadowHost = host;
}

export function getExplorerShadowHost(): HTMLElement {
	if (!_shadowHost) {
		throw new Error('Explorer shadow host not initialized');
	}
	return _shadowHost;
}
